import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
interface CountdownProps {
  label?: string;
  compact?: boolean;
}
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function Countdown({
  label,
  compact = false
}: CountdownProps) {
  // 48 horas de precio especial, con cuenta regresiva viva.
  const [seconds, setSeconds] = useState(47 * 3600 + 59 * 60 + 5);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  const box = 'flex flex-col items-center justify-center rounded-lg border border-[var(--rose)]/30 bg-[var(--bg-deep)] px-3 py-2 min-w-[56px] sm:min-w-[68px]';
  return <div className="flex flex-col items-center gap-3" data-id="element-48" data-mp="10aim40wk8f69">
      {label && <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-[var(--rose)]" data-id="element-49" data-mp="15awlkuk3igso">
          <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="xz3krx77cw89" />
          {label}
        </p>}
      <div className="flex items-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Tiempo restante ${hrs} horas ${mins} minutos ${secs} segundos`} data-id="element-51" data-mp="szzcd8s3r2iz">
        {[{
        v: hrs,
        l: 'hs'
      }, {
        v: mins,
        l: 'min'
      }, {
        v: secs,
        l: 'seg'
      }].map((unit, i) => <React.Fragment key={unit.l} data-id="element-52" data-mp="a3r7w76wyvoq" data-mpi={i}>
            <div className={box} data-id="element-53" data-mp="a5285x15hlb3">
              <span className={`font-serif-display leading-none text-[var(--text)] ${compact ? 'text-2xl sm:text-3xl' : 'text-3xl sm:text-4xl'}`} data-id="element-54" data-mp="o30lr07nddpj">
                {pad(unit.v)}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-[var(--text-soft)]" data-id="element-55" data-mp="1zgchent96q0m">
                {unit.l}
              </span>
            </div>
            {i < 2 && <span className="text-2xl font-bold text-[var(--rose)]" data-id="element-56" data-mp="s5es35496eyc">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}